import { toJS } from 'mobx';
import PropTypes from 'prop-types';
import React from 'react';
import CurrencyFormat from 'react-currency-format';
import { Popup, Table } from 'semantic-ui-react';
import styled, { css } from 'styled-components';
import { LazyImage, LinkButton, TableButton } from '..';
import { formatDateTime } from '../../shared/utils/dateTime';
import { contentType } from './constants';
import { bodySchemaArrayPropType, cellDataPropType } from './propTypes';
import {
  concatArgsWithValuesAsString,
  getButtonUrlFromArgsAndData,
  getDataValue,
  getDataValueFromJson,
  getProductStateColor,
  getRuleStyle,
  isCurrencyText,
  isDataKey,
  isJson,
} from './utility';

export const TableCells = ({ data, loadData, rowIndex, schema }) => (
  <>{schema.map((cell) => tableCellReducer(data, cell, loadData, rowIndex))}</>
);

TableCells.propTypes = {
  data: cellDataPropType,
  schema: bodySchemaArrayPropType,
};

const tableCellReducer = (data, action, loadData, rowIndex) => {
  const { image, buttons, text, dateTime, tableButtons, modalButton } =
    contentType;
  const {
    content: { type: componentType },
    index,
  } = action;

  // console.log('tableReducer', { rowData: toJS(data?.row), action, loadData, rowIndex });

  switch (componentType) {
    case buttons:
      return (
        <ButtonTableCell
          data={data}
          key={index}
          loadData={loadData}
          rowIndex={rowIndex}
          schema={action}
        />
      );
    case dateTime:
      return (
        <DateTableCell
          data={data}
          key={index}
          loadData={loadData}
          rowIndex={rowIndex}
          schema={action}
        />
      );
    case image:
      return (
        <ImageTableCell
          data={data}
          key={index}
          loadData={loadData}
          rowIndex={rowIndex}
          schema={action}
        />
      );
    case tableButtons:
      return (
        <TableButtonTableCell
          data={data}
          key={index}
          loadData={loadData}
          rowIndex={rowIndex}
          schema={action}
        />
      );
    case text:
      return (
        <TextTableCell
          data={data}
          key={index}
          loadData={loadData}
          rowIndex={rowIndex}
          schema={action}
        />
      );
    default:
      return (
        <Table.Cell
          content={`Content type of (${componentType}) is INVALID. Please update your schema for this cell to use one of the existing content types, or create a new component to match this content type: ${JSON.stringify(
            contentType,
          )}`}
          data-testid={`invalid-component-r${rowIndex}c${index}`}
          negative
        />
      );
  }
};

// ***********************************************
// Cell Components
// ***********************************************

export const TableSchemaComponentCell = ({
  data,
  schema,
  loadData,
  rowIndex,
}) => {
  const { value, index, component: SchemaComponent, props } = schema;
  const text = getDataValue(data, value);
  console.log('TableSchemaComponentCell', { schema });
  return (
    <Table.Cell data-testid={`table-cell-r${rowIndex}c${index}`}>
      {/* <SchemaComponent {...props} /> */}
      test
    </Table.Cell>
  );
};

// export const ModalButtonTableCell = ({ data, schema, loadData, rowIndex }) => {
//   const {
//     content: { value: buttons },
//     debug,
//     index,
//   } = schema;
//   // console.log('ModalButtonTableCell', { data, schema, loadData, rowIndex });
//   return (
//     <Table.Cell data-testid={`table-cell-r${rowIndex}c${index}`}>
//       {buttons.map(
//         ({
//           value,
//           text,
//           style,
//           basic,
//           primary,
//           size,
//           icon,
//           fn,
//           url,
//           state,
//           args,
//           key: dataKey,
//         }) => {
//           // const targetUrl = async () => await getButtonUrlFromArgsAndData(url, fn, args, data);
//           const targetUrl = getButtonUrlFromArgsAndData(url, fn, args, data);
//           const targetState = getDataValueFromJson(state, data);
//           // const urlToUse = targetState
//           //   ? { pathname: targetUrl, state: targetState }
//           //   : targetUrl;
//           const key = `${text}_${getDataValue(data, dataKey)}`;
//           // console.log('state, data', { state, data })

//           const getTextValue = () => {
//             if (isJson(text)) return text[getDataValue(data, value)];
//             return getDataValue(data, text) || text;
//           };

//           const ruleStyle = getRuleStyle(style, getDataValue(data, value));
//           const textToDisplay = getTextValue();

//           if (debug) {
//             console.log('TableButtonTableCell', {
//               dataValue: getDataValue(data, value),
//               value,
//               schema,
//               data,
//               row: toJS(data.row),
//               targetUrl,
//               targetState,
//               key,
//               textToDisplay,
//               text,
//               style,
//               state,
//               icon,
//               fn,
//               url,
//               args,
//               dataKey,
//               buttons,
//               index,
//               ruleStyle,
//             });
//           }

//           const clickHandler = () => {
//             targetUrl();

//             data.state[fn].callback({
//               data,
//               row: toJS(data.row),
//               reloadData: loadData,
//             });
//           };

//           // TODO: Work this into the schema files
//           const getHelpText = () => {
//             if (['Disable', 'Enable'].includes(textToDisplay)) {
//               const memberName = getDataValue(data, 'member');
//               if (textToDisplay === 'Enable')
//                 return `Click to enable ${memberName}. They currently do not have access to bid.`;
//               return `Click to disable ${memberName} from bidding on the Simulcast platform.`;
//             }
//             return null;
//           };

//           return (
//             <TableButton
//               // color={color}
//               icon={icon}
//               key={key}
//               primary={primary}
//               size={size}
//               text={textToDisplay}
//               onClick={clickHandler}
//               basic={basic}
//               style={ruleStyle}
//               helpText={getHelpText()}
//             />
//           );
//         },
//       )}
//     </Table.Cell>
//   );
// };

export const TableButtonTableCell = ({ data, schema, loadData, rowIndex }) => {
  const {
    content: { value: buttons },
    debug,
    index,
  } = schema;

  return (
    <Table.Cell data-testid={`table-cell-r${rowIndex}c${index}`}>
      {buttons.map(
        ({
          args,
          basic,
          fn,
          icon,
          key: dataKey,
          primary,
          size,
          state,
          style,
          text,
          url,
          value,
        }) => {
          // console.log('TableButtonTableCell > buttons', {
          //   value,
          //   text,
          //   style,
          //   basic,
          //   primary,
          //   size,
          //   icon,
          //   fn,
          //   url,
          //   state,
          //   args,
          //   key: dataKey,
          // })

          // const targetUrl = async () => await getButtonUrlFromArgsAndData(url, fn, args, data);
          const targetUrl = getButtonUrlFromArgsAndData(url, fn, args, data);
          const targetState = getDataValueFromJson(state, data);
          // const urlToUse = targetState
          //   ? { pathname: targetUrl, state: targetState }
          //   : targetUrl;
          const key = `${text}_${getDataValue(data, dataKey)}`;
          // console.log('state, data', { state, data })

          const getTextValue = () => {
            if (isJson(text)) return text[getDataValue(data, value)];
            return getDataValue(data, text) || text;
          };

          const ruleStyle = getRuleStyle(style, getDataValue(data, value));
          const textToDisplay = getTextValue();

          if (debug) {
            console.log('TableButtonTableCell', {
              args,
              buttons,
              data,
              dataKey,
              dataValue: getDataValue(data, value),
              fn,
              icon,
              index,
              key,
              row: toJS(data.row),
              ruleStyle,
              schema,
              state,
              style,
              targetState,
              targetUrl,
              text,
              textToDisplay,
              url,
              value,
            });
          }

          const clickHandler = () => {
            targetUrl();

            if (data.state[fn].callback) {
              data.state[fn].callback({
                data,
                row: toJS(data.row),
                reloadData: loadData,
              });
            }
          };

          // TODO: Work this into the schema files
          const getHelpText = () => {
            if (['Disable', 'Enable'].includes(textToDisplay)) {
              const memberName = getDataValue(data, 'member');
              if (textToDisplay === 'Enable')
                return `Click to enable ${memberName}. They currently do not have access to bid.`;
              return `Click to disable ${memberName} from bidding on the Simulcast platform.`;
            }
            return null;
          };

          return (
            <TableButton
              // color={color}
              basic={basic}
              helpText={getHelpText()}
              icon={icon}
              key={key}
              onClick={clickHandler}
              primary={primary}
              size={size}
              style={ruleStyle}
              text={textToDisplay}
            />
          );
        },
      )}
    </Table.Cell>
  );
};

export const ButtonTableCell = ({ data, loadData, rowIndex, schema }) => {
  const {
    content: { value: buttons },
    index,
    debug,
    style,
  } = schema;
  return (
    <Table.Cell data-testid={`table-cell-r${rowIndex}c${index}`} style={style}>
      {buttons.map(
        ({
          args,
          basic,
          color,
          fn,
          icon,
          key: dataKey,
          primary,
          size,
          state,
          text,
          url,
        }) => {
          const targetUrl = getButtonUrlFromArgsAndData(url, fn, args, data);
          const targetState = getDataValueFromJson(state, data);
          const urlToUse = targetState
            ? { pathname: targetUrl, state: targetState }
            : targetUrl;

          console.log('urlToUse', { targetState, urlToUse });
          const textToDisplay = getDataValue(data, text) || text;
          const keyLabel = isDataKey(text)
            ? `${text.substring(1, text.length - 1)}=`
            : '';
          const dataKeyLabel = `${dataKey.substring(1, dataKey.length - 1)}=`;
          const key = `${keyLabel}${textToDisplay}~${dataKeyLabel}${getDataValue(
            data,
            dataKey,
          )}`;

          // console.log('ButtonTableCell', { schema, data, targetUrl, targetState, key, textToDisplay, text, state, icon, fn, url, args, dataKey });
          if (debug) {
            console.log('ButtonTableCell', {
              schema,
              data,
              row: toJS(data.row),
              targetUrl,
              targetState,
              key,
              textToDisplay,
              text,
              state,
              icon,
              fn,
              url,
              args,
              dataKey,
              buttons,
              index,
            });
          }

          return (
            <LinkButton
              basic={basic}
              color={color}
              icon={icon}
              key={key}
              primary={primary}
              size={size}
              text={textToDisplay}
              url={urlToUse}
            />
          );
        },
      )}
    </Table.Cell>
  );
};

ButtonTableCell.propTypes = {
  data: cellDataPropType,
  schema: PropTypes.shape({
    component: PropTypes.elementType,
    content: PropTypes.exact({
      type: PropTypes.oneOf([contentType.buttons]).isRequired,
      value: PropTypes.arrayOf(
        PropTypes.shape({
          args: PropTypes.arrayOf(PropTypes.string.isRequired),
          basic: PropTypes.bool,
          color: PropTypes.string,
          fn: PropTypes.func,
          icon: PropTypes.string,
          key: PropTypes.string.isRequired,
          primary: PropTypes.bool,
          size: PropTypes.string,
          state: PropTypes.object,
          text: PropTypes.string.isRequired,
          url: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
          ]),
        }),
      ).isRequired,
    }).isRequired,
    format: PropTypes.string,
    index: PropTypes.number.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string.isRequired),
    ]).isRequired,
  }).isRequired,
};

export const ImageTableCell = ({ data, loadData, rowIndex, schema }) => {
  const {
    content: {
      value: { alt },
    },
    index,
    value,
  } = schema;
  const url = data.row[value];
  const altText = concatArgsWithValuesAsString(alt, data);
  return (
    <Table.Cell data-testid={`table-cell-r${rowIndex}c${index}`}>
      <LazyImage alt={altText} url={url} />
    </Table.Cell>
  );
};

ImageTableCell.propTypes = {
  data: cellDataPropType,
  schema: PropTypes.shape({
    component: PropTypes.elementType,
    content: PropTypes.exact({
      type: PropTypes.oneOf([contentType.image]).isRequired,
      value: PropTypes.shape({
        alt: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
      }),
    }).isRequired,
    format: PropTypes.string,
    index: PropTypes.number.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
};

export const DateTableCell = ({ data, rowIndex, schema }) => {
  const { format, index, style, value } = schema;
  const ruleStyle = getRuleStyle(style, value);
  return (
    <Table.Cell
      data-testid={`table-cell-r${rowIndex}c${index}`}
      style={ruleStyle}
    >
      {formatDateTime(data.row[value], format)}
    </Table.Cell>
  );
};

DateTableCell.propTypes = {
  data: cellDataPropType,
  schema: PropTypes.shape({
    component: PropTypes.elementType,
    content: PropTypes.exact({
      type: PropTypes.oneOf([contentType.dateTime]).isRequired,
      value: PropTypes.oneOf(['value']).isRequired,
    }).isRequired,
    format: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
};

export const TextTableCell = ({ data, rowIndex, schema }) => {
  const { format, index, shaded: isProductStateCell, style, value } = schema;
  const text = getDataValue(data, value);
  const formatAsCurrency = isCurrencyText(format);
  const ruleStyle = getRuleStyle(style, text);

  switch (true) {
    case formatAsCurrency:
      return (
        <Table.Cell
          data-testid={`table-cell-r${rowIndex}c${index}`}
          style={ruleStyle}
        >
          <FormattedCurrencyValue value={text} />
        </Table.Cell>
      );
    case isProductStateCell:
      return (
        <ShadedProductStateCell
          data-testid={`table-cell-r${rowIndex}c${index}`}
          productstate={text}
          style={ruleStyle}
        >
          {text}
        </ShadedProductStateCell>
      );
    default:
      return (
        <Table.Cell
          data-testid={`table-cell-r${rowIndex}c${index}`}
          style={ruleStyle}
        >
          {text}
        </Table.Cell>
      );
  }
};

TextTableCell.propTypes = {
  data: cellDataPropType,
  schema: PropTypes.shape({
    component: PropTypes.elementType,
    content: PropTypes.exact({
      type: PropTypes.oneOf([contentType.text]).isRequired,
      value: PropTypes.oneOf(['value']).isRequired,
    }).isRequired,
    format: PropTypes.string,
    index: PropTypes.number.isRequired,
    style: PropTypes.arrayOf(
      PropTypes.shape({
        expr: PropTypes.string.isRequired,
        scope: PropTypes.shape({
          x: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        }).isRequired,
        style: PropTypes.object.isRequired,
      }),
    ),
    value: PropTypes.string.isRequired,
  }).isRequired,
};

// ***********************************************
// Cell formatting
// ***********************************************

export const ShadedAmountCell = styled(Table.Cell)`
  ${({ bgColor, color }) => css`
    background-color: ${bgColor};
    color: ${color};
    border: none;
    font-weight: bold;
    text-transform: uppercase;
  `}
`;

export const ShadedProductStateCell = styled(Table.Cell)`
  ${({ productstate }) => css`
    background-color: ${getProductStateColor(productstate).bgColor};
    color: ${getProductStateColor(productstate).color};
    border: none;
    font-weight: bold;
    text-transform: uppercase;
  `}
`;

export const FormattedCurrencyValue = ({ value }) => (
  <CurrencyFormat
    displayType={'text'}
    prefix={'$'}
    thousandSeparator={true}
    value={value}
  />
);

FormattedCurrencyValue.propTypes = {
  value: PropTypes.number.isRequired,
};
